
enum VideoFilterEvents {
    resetfilter = "[VideoFilterEvent] Resetfilter"
}

export default VideoFilterEvents;
